import styled from "styled-components";
import Button from "components/Buttons/ThemeButton";

export const Container = styled.div`
	gap: 0.8em;
	margin-top: 0.9em;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	width: 100%;
`;

export const CustomButton = styled(Button)`
	margin-top: 1em;
	width: 100%;
	height: 3.5em;
	font-size: 1em;

	@media (min-width: 900px) {
		max-width: 14.7em;
	}
	//text-transform: none;
`;
